jQuery(document).ready(function($) {

  const processSliderSettings = {
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  }

  $('.process-slider').slick(processSliderSettings)


  var processSlider = {

    construct: function() {
      this.navItems = $('.process-navigation li');
      this.slider = $('.process-slider');
      this.navItems.on('click', this.goToSlide.bind(this))
      this.slider.on('beforeChange', this.respondToSliderChange.bind(this))
    },

    goToSlide: function(event) {
      let i = this.navItems.index(event.target)
      this.setActiveNavItem(i);
      this.slider.slick('slickGoTo', i);
    },

    setActiveNavItem: function(i) {
      this.navItems.each(function(index, item) {
        index === i ? $(item).addClass('active') : $(item).removeClass('active');
      })
    },

    respondToSliderChange: function(e, s, c, n) {
      this.setActiveNavItem(n);
      this.handleShadows(s, n);
    },

    handleShadows: function(slick, next) {
      slick.$slides.toArray().forEach(function(slide) {
        $(slide).removeClass('no-shadow');
      })
      $(slick.$slides.get(next - 1)).addClass('no-shadow')
    }

  }

  processSlider.construct();


  $(window).on('resize orientationchange', function() {
    var slider = $('.process-slider');

    if(!slider.hasClass('slick-initialized')){
         slider.slick(processSliderSettings);
    }
  })

})
